module.exports = __webpack_public_path__ + "img/red-1.aaa7f943.svg";